import { useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import axios from 'axios';
import Card from "../../../components/Card/Card";// Adjust path if necessary
import styles from './sportstaette.module.css';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from "keen-slider/react";
import { useAutoPlay } from "../../../../code/AutoPlaySlider";
function Sportstaette({ anlage, setModalImage }) {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    // null or image path
    const [sliderRef, slider] = useKeenSlider({
        loop: true,
        slides: {
            perView: 3,
            spacing: 15,
        },
    });

    useAutoPlay(slider);

    const parseListByCommaOrNewline = (str) =>
        str && str.length > 0
            ? str.split(/\s*,\s*|\r?\n/).filter(Boolean)
            : [];

    const parseListByNewline = (str) =>
        str && str.length > 0
            ? str.split(/\r?\n/).filter(Boolean)
            : [];

    const ausstattungList = parseListByCommaOrNewline(anlage.ausstattung);
    const verboteList = parseListByCommaOrNewline(anlage.verbote);
    const buslinienList = parseListByCommaOrNewline(anlage.buslinien);
    const anfahrtList = parseListByNewline(anlage.anfahrt);

    const showkurztext = anlage.kurztext && anlage.kurztext.length > 0;
    const showAusstattung = ausstattungList.length > 0;
    const showVerbote = verboteList.length > 0;
    const showAnfahrt = anfahrtList.length > 0;
    const isTwoByTwo = showAusstattung && showVerbote;

    useEffect(() => {
        if (location.hash.replace("#", "") === String(anlage.id)) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [location.hash, anlage.id]);

    useEffect(() => {
        if (!anlage.id) return;

        axios.get(`/api/sportstaetten/images/${anlage.id}`)
            .then(res => setImages(res.data))
            .catch(err => {
                console.error("Fehler beim Laden der Bilder:", err);
                setImages([]);
            });
    }, [anlage.id]);

    return (

        <Card
            id={String(anlage.id)}
            title={`${anlage.bezeichnung ? anlage.bezeichnung + (anlage.name ? ': ' : '') : ''}${anlage.name || ''}`}

            isOpen={isOpen}
            setIsOpen={setIsOpen}
            icon="/assets/icons/google-map-icon.png"
            iconText={`Karte zu ${anlage.bezeichnung} ${anlage.name || ''}`}
            onIconClick={() => {
                if (anlage.maps_link) {
                    window.open(anlage.maps_link, '_blank', 'noopener,noreferrer');
                }
            }}
        >
            <div className={styles.modulContainer}>
                {showkurztext && <div className={styles.cardTile}><p className={styles.kurztext}>{anlage.kurztext}</p></div>}

                <div className={`${styles.overview} ${isTwoByTwo ? styles.twoByTwo : styles.twoByOne}`}>
                    <div className={styles.cardTile}>
                        <p className={styles.subtitle}>Adresse</p>
                        <table className={styles.table}>
                            <tbody>
                                <tr>
                                    <td>Straße & Nr:</td>
                                    <td>{anlage.strasse}</td>
                                </tr>
                                <tr>
                                    <td>PLZ, Ort:</td>
                                    <td>{anlage.plz} {anlage.stadt}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={styles.cardTile}>
                        <p className={styles.subtitle}>Bushaltestelle</p>
                        <table className={styles.table}>
                            <tbody>
                                <tr>
                                    <td>Haltestelle:</td>
                                    <td>{anlage.bushaltestelle}</td>
                                </tr>
                                <tr>
                                    <td>Buslinien:</td>
                                    <td>{buslinienList.join(", ")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {showAusstattung && !showVerbote && (
                        <div className={`${styles.cardTile} ${styles.fullWidth}`}>
                            <p className={styles.subtitle}>Ausstattung</p>
                            <ul className={styles.flexList}>
                                {ausstattungList.map((item, i) => (<li key={i}>{item}</li>))}
                            </ul>
                        </div>
                    )}

                    {showVerbote && !showAusstattung && (
                        <div className={`${styles.cardTile} ${styles.fullWidth}`}>
                            <p className={styles.subtitle}>Verbote</p>
                            <ul className={styles.flexList}>
                                {verboteList.map((item, i) => (<li key={i}>{item}</li>))}
                            </ul>
                        </div>
                    )}

                    {showAusstattung && showVerbote && (
                        <>
                            <div className={styles.cardTile}>
                                <p className={styles.subtitle}>Ausstattung</p>
                                <ul className={styles.flexList}>
                                    {ausstattungList.map((item, i) => (<li key={i}>{item}</li>))}
                                </ul>
                            </div>
                            <div className={styles.cardTile}>
                                <p className={styles.subtitle}>Verbote</p>
                                <ul className={styles.flexList}>
                                    {verboteList.map((item, i) => (<li key={i}>{item}</li>))}
                                </ul>
                            </div>
                        </>
                    )}
                </div>

                <div className={styles.cardTile}>
                    <p className={styles.subtitle}>Anfahrt</p>
                    {showAnfahrt ? (
                        <ol>
                            {anfahrtList.map((item, i) => (<li key={i}>{item}</li>))}
                        </ol>
                    ) : (
                        <p>{anlage.anfahrt}</p>
                    )}
                </div>

                {images.length > 0 && (
                    <div ref={sliderRef} className="keen-slider">
                        {images.map((img, i) => (
                            <div key={img.id || i} className="keen-slider__slide">
                                <img
                                    src={img.image_path}
                                    alt={`Bild ${i + 1}`}
                                    className={styles.carouselImage}
                                    onClick={() => setModalImage(img.image_path)}
                                    style={{ cursor: "pointer" }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Card >

    );
}

export default Sportstaette;
